export function isDate(value) {
    return value instanceof Date;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/charts/dist/es6/charts/chartComp/typeChecker.js
// module id = 3235
// module chunks = 0